<h1 mat-dialog-title i18n>
	Associated app keys <small class="align-top">- {{dialogData.terms.displayName}}</small>

	<button
		mat-flat-button
		color="primary"
		type="button"
		class="app-key-menu-btn d-block d-sm-inline-block float-sm-right app-legal__associate"
		(click)="associateAppKeys()"
		[disabled]="!dialogData.editable || !hasActive || unassignedAppKeys.length === 0"
	>
		Associate
	</button>
</h1>
<div mat-dialog-content class="main-content">
	<p *ngIf="!loading && appKeys.length === 0 && unassignedAppKeys.length > 0 && hasActive" i18n>This legal document is currently not associated with any app keys. Click <button
		title="View legal"
		type="button"
		class="button-link"
		(click)="associateAppKeys()"
		[disabled]="!dialogData.editable || !hasActive"
	>Associate</button> to begin.</p>

	<p *ngIf="!loading && !hasActive" i18n>There is currently no active versions of this legal document. To associate it to an app key, upload or publish an active document first.</p>

	<p *ngIf="!loading && appKeys.length === 0 && unassignedAppKeys.length === 0" i18n>This company does not have any app keys available. Create an app key to get started.</p>

	<ng-container *ngIf="!loading && appKeys.length > 0">
		<div class="custom-table">
			<div class="row custom-table-header main-header">
				<div class="col-sm-auto bg- header-icon">
					<span class="material-icons">vpn_key</span>
				</div>
				<div class="col align-self-center">
					<span class="title" i18n>App keys</span>
				</div>
				<div class="col-sm-auto mr-2">
					<mat-form-field appearance="standard" dense class="w-100">
						<input matInput type="text" placeholder="Search" i18n-placeholder [formControl]="searchControl"/>
					</mat-form-field>
				</div>
			</div>
			<div class="custom-table-body">
				<div class="row align-items-center mx-0 px-1 custom-table-item bordered-top" id="{{appKey.clientId}}" *ngFor="let appKey of appKeysFiltered; index as i" [ngClass]="{'opened': i === openedMenu, 'disabled': !appKey.valid, 'text-muted': !appKey.valid}" [matTooltip]="!appKey.valid ? 'Disabled' : ''" [matTooltipDisabled]="appKey.valid">

					<div class="col document-name">{{appKey.name}}</div>
					<div class="col-sm-auto small-btn">
						<button
							class="btn border-0 badge badge-pill badge-info deploy-badge mr-2 py-1 px-3 d-none d-md-inline-block"
							title="Click to copy client ID"
							i18n-title
							[appCopyToClipboard]="appKey.clientId"
							[appCopyToClipboardIcon]="true"
							appCopyToClipboardVisibility="none"
						>{{appKey.clientId}}</button>
						<span
							class="badge badge-pill badge-secondary deploy-badge mr-2 py-1 px-3 text-capitalize {{ appKey.provider != 'local' ? 'badge-' + appKey.provider : '' }}"
						>{{appKey.provider}}</span>
						<span
							class="badge badge-pill badge-secondary deploy-badge mr-2 py-1 px-3"
						>{{appKey.clusterName ? appKey.clusterName : appKey.clusterId}}</span>

						<button
							type="button"
							mat-icon-button
							[matMenuTriggerFor]="appKeyMenu"
							(menuClosed)="openedMenu = null"
							(menuOpened)="openedMenu = i"
							[disabled]="!appKey.valid"
							class="app-key-association__actions"
						>
							<mat-icon class="material-icons">more_vert</mat-icon>
						</button>
						<mat-menu #appKeyMenu="matMenu">
							<button
								mat-menu-item
								i18n
								title="Disassociate app key"
								i18n-title
								(click)="unassociateAppKey(appKey)"
								class="app-key-association__unassociate"
							>Disassociate app key</button>
						</mat-menu>
					</div>
				</div>
			</div>
		</div>
		<mat-paginator
			*ngIf="pageResults > 10"
			[length]="pageResults"
			[pageSize]="pageSize"
			[pageIndex]="pageIndex"
			[pageSizeOptions]="[10, 25, 50]"
			(page)="filterAppKeys($event)"
		></mat-paginator>
	</ng-container>
</div>
<div mat-dialog-actions class="row justify-content-md-center mb-0">
	<div class="col-6 align-self-end text-center">
		<button class="w-100" mat-flat-button mat-dialog-close i18n>Done</button>
	</div>
</div>
